import * as React from "react";
function SvgGeomarks(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M16.1 8.5c-2.3 0-4.1 1.9-4.1 4.1 0 2.3 1.9 4.1 4.1 4.1 1.1 0 2.1-.4 2.9-1.2s1.2-1.8 1.2-2.9a4 4 0 00-4.1-4.1zm1.5 5.7c-.4.4-.9.6-1.5.6l-.1.7v-.7c-1.2 0-2.1-1-2.1-2.1s1-2.1 2.1-2.1 2.1 1 2.1 2.2c.2.4-.1.9-.5 1.4zm12-9.5a7.34 7.34 0 00-5.2-2.1c-1.7 0-3.4.6-4.7 1.7-1.2-.5-2.4-.8-3.8-.8-1.3 0-2.6.3-3.8.8A7.23 7.23 0 00.2 9.9c0 3.7 5.8 12.2 6.5 13.2l.8 1.2.8-1.2c0-.1.7-1 1.6-2.5 2.1 4 4.7 7.8 5.2 8.5l.8 1.2.8-1.2c.5-.7 3.1-4.5 5.2-8.5.9 1.4 1.6 2.4 1.6 2.5l.8 1.2.8-1.2c.7-1 6.5-9.5 6.5-13.2.2-2-.6-3.8-2-5.2zm-22.1 16c-2-3.1-5.3-8.6-5.3-10.8 0-1.6.7-3.1 1.9-4.1 1.9-1.5 4.4-1.6 6.3-.4-.8.7-1.5 1.5-2.1 2.4-.9-.4-2-.3-2.8.4-1 .9-1.1 2.5-.2 3.5.4.5 1 .8 1.6.8 0 1.5.8 3.7 1.9 6-.4.8-.9 1.6-1.3 2.2zm8.5 6c-2.5-3.8-7-11.2-7-14.2 0-3.9 3.1-7 7-7s7 3.1 7 7c0 3-4.5 10.4-7 14.2zm8.5-6c-.4-.6-.9-1.4-1.4-2.2 1.1-2.3 1.9-4.5 1.9-6 .6-.1 1.2-.3 1.7-.8.9-1 .8-2.6-.2-3.5-.8-.7-1.9-.8-2.8-.4-.5-.9-1.2-1.7-2.1-2.3.8-.5 1.8-.8 2.9-.9 1.4 0 2.7.5 3.7 1.5s1.6 2.3 1.6 3.7c0 2.3-3.3 7.8-5.3 10.9z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgGeomarks);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
